import { ITienThuaHocSinh } from "../../../model/respone/category/ITienThuaHocSinh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTienThuaHocSinhActionTypeDefine = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as ITienThuaHocSinh[],
  LOAD_ERROR: "",

  LOAD_HOCSINH_START: 0,
  LOAD_HOCSINH_SUCCESS: {} as ITienThuaHocSinh,
  LOAD_HOCSINH_ERROR: "",
};

export const eTienThuaHocSinhActionTypeIds = generateActionTypeIds(
  eTienThuaHocSinhActionTypeDefine,
  "TIEN_THUA_HOC_SINH"
);

export type ITienThuaHocSinhActions = IGenericActionType<
  typeof eTienThuaHocSinhActionTypeDefine,
  "TIEN_THUA_HOC_SINH"
>;
